import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import React from 'react'
import { Button } from 'react-bootstrap'
import { FormattedNumber } from 'react-intl'
import { getDuration } from 'utils'

function TrackingInfo(props) {
  const { onFinish, onToggle, tracking } = props
  const [duration, setDuration] = React.useState(getDuration([]))
  const { h, m, s } = duration
  const paused = React.useMemo(() => tracking.length % 2 === 0, [tracking])

  React.useEffect(() => {
    let interval
    const update = () => {
      setDuration(getDuration(tracking))
    }
    update()
    if (!paused) {
      interval = setInterval(update, 1000)
    }
    return () => clearInterval(interval)
  }, [tracking, paused])

  const toggle = event => {
    onToggle()
    event.target.blur()
  }

  return (
    <div className="session-tracker p-2 py-3 h5 text-center bg-success text-white font-weight-bold d-flex d-md-block justify-content-around align-items-center">
      <div className="timer d-inline-block text-left">
        <FormattedNumber value={h} minimumIntegerDigits={2} />
        :<FormattedNumber value={m} minimumIntegerDigits={2} />
        :<FormattedNumber value={s} minimumIntegerDigits={2} />
      </div>
      <div className="d-inline-block ml-md-3">
        <Button variant="warning" size="sm" className="ml-1" onClick={toggle}>
          <FontAwesomeIcon icon={paused ? 'play' : 'pause'} className="mr-1" />
          {paused ? 'RESUME' : 'PAUSE'}
        </Button>
        <Button variant="warning" size="sm" className="ml-1" onClick={onFinish}>
          <FontAwesomeIcon icon="stop" className="mr-1" />
          STOP
        </Button>
      </div>
    </div>
  )
}

TrackingInfo.propTypes = {
  tracking: PropTypes.array.isRequired,
  onFinish: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
}

export default TrackingInfo
